module.exports = __webpack_public_path__ + "img/logo-mrs.96145912.png";